'use client';

import { c as _c } from "react/compiler-runtime";
import { FeatherCheckCircle, FeatherChevronRight, FeatherGrid, FeatherList, FeatherUser } from '@subframe/core';
import type { ReactNode } from 'react';
import type { UseNegociacaoSelfReturn } from '../hooks';
import { SimpleLogoHeader } from './SimpleLogoHeader';
interface SuccessScreenProps {
  vm: UseNegociacaoSelfReturn;
}
interface OpcaoInicio {
  icon: ReactNode;
  titulo: string;
  descricao: string;
}
const OPCOES_INICIO: OpcaoInicio[] = [{
  icon: <FeatherList className="text-brand-600" />,
  titulo: 'Negociação em lote',
  descricao: 'Envie propostas para múltiplos contatos de uma vez'
}, {
  icon: <FeatherUser className="text-brand-600" />,
  titulo: 'Negociação individual',
  descricao: 'Inicie uma negociação com um único contato'
}, {
  icon: <FeatherGrid className="text-brand-600" />,
  titulo: 'Explorar a plataforma',
  descricao: 'Conheça o dashboard e outras páginas da Arbitralis'
}];
export const SuccessScreen = t0 => {
  const $ = _c(17);
  const {
    vm
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <SimpleLogoHeader />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="bg-success-50 flex h-16 w-16 items-center justify-center rounded-full"><FeatherCheckCircle className="text-success-700 h-7 w-7" /></div>;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <h1 className="text-heading-dark text-xl font-semibold sm:text-[26px]">Tudo pronto! Bem-vindo à Lexi</h1>;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== vm.perfil.email) {
    t4 = vm.perfil.email.trim() || "o e-mail cadastrado";
    $[3] = vm.perfil.email;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== t4) {
    t5 = <div className="flex max-w-[460px] flex-col items-center gap-2 text-center">{t3}<p className="text-label-muted text-sm leading-relaxed">Sucesso com o seu pagamento! Sua conta foi criada e enviamos um link de acesso para{" "}<span className="text-heading-dark font-semibold">{t4}</span>.</p></div>;
    $[5] = t4;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== vm.reiniciarFluxo) {
    t6 = OPCOES_INICIO.map(opcao => <button key={opcao.titulo} type="button" onClick={vm.reiniciarFluxo} className="flex items-center gap-3.5 rounded-[10px] border border-solid border-neutral-200 px-4 py-3.5 text-left transition-colors hover:bg-neutral-50"><div className="bg-brand-50 flex h-9 w-9 flex-none items-center justify-center rounded-[8px]">{opcao.icon}</div><div className="flex-1"><div className="text-heading-dark text-sm font-semibold">{opcao.titulo}</div><div className="text-xs text-neutral-500">{opcao.descricao}</div></div><FeatherChevronRight className="text-neutral-500" /></button>);
    $[7] = vm.reiniciarFluxo;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== t6) {
    t7 = <div className="flex w-full max-w-[420px] flex-col gap-2.5">{t6}</div>;
    $[9] = t6;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] !== vm.planoResumoLabel) {
    t8 = <span className="mt-2 text-[13px] text-neutral-500">{vm.planoResumoLabel} · 7 dias grátis</span>;
    $[11] = vm.planoResumoLabel;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  let t9;
  if ($[13] !== t5 || $[14] !== t7 || $[15] !== t8) {
    t9 = <div className="flex min-h-screen w-full flex-col bg-white">{t1}<div className="flex flex-1 flex-col items-center justify-center gap-6 px-6 py-12">{t2}{t5}{t7}{t8}</div></div>;
    $[13] = t5;
    $[14] = t7;
    $[15] = t8;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  return t9;
};